import React from 'react';
import { Table, Select, Typography } from 'antd';
import { clients, roles } from '../../mockData';
import './Permissions.css';

function ClientPermissions() {
  const { Title } = Typography;
  const roleOptions = roles.map((r) => ({ label: r.name, value: r.name }));

  const columns = [
    { title: 'Client', dataIndex: 'name', key: 'name' },
    { title: 'Contact', dataIndex: 'contact', key: 'contact' },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    {
      title: 'Role',
      key: 'role',
      render: () => (
        <Select
          options={roleOptions}
          defaultValue={roleOptions[0]?.value}
          style={{ width: 180 }}
          onChange={(v) => console.log('Mock set role', v)}
        />
      ),
    },
  ];

  return (
    <div className="agency-clients-permissions">
      <Title level={3}>Client Permissions</Title>
      <Table rowKey="id" columns={columns} dataSource={clients} pagination={{ pageSize: 5 }} />
    </div>
  );
}

export default ClientPermissions;
